import { Middleware } from '@reduxjs/toolkit';

const widthMiddleware: Middleware = ({ dispatch }) => {
	const handler = () => {
		const width = document.body.clientWidth;
		dispatch({ type: 'width/change', payload: width });
		document.cookie = `width=${width};max-age=31536000`;
	};
	if (typeof window !== 'undefined') {
		window.addEventListener('resize', handler);
		setTimeout(handler, 100);
	}

	return (next) => (action) => next(action);
};

export default widthMiddleware;
